export var errorUtil = /*#__PURE__*/function (errorUtil) {
  errorUtil.errToObj = message => typeof message === "string" ? {
    message
  } : message || {};
  // biome-ignore lint:
  errorUtil.toString = message => typeof message === "string" ? message : message?.message;
  return errorUtil;
}(errorUtil || {});